import FocusManagement from './FocusManagement.js';

function init() {
  document.querySelectorAll('.faq__q').forEach(q => q.addEventListener('click', toggleExpander__faq));
  document.querySelectorAll('.submenu__wrap').forEach(s => configExpandable(s));
}

function toggleExpander__faq() {
  const isExpanding = (this.getAttribute('aria-expanded') === 'false');
  const faqItem = this.closest('.faq__item');
  const answerWrap = faqItem.querySelector('.faq__aWrap');
  this.setAttribute('aria-expanded', isExpanding ? 'true' : 'false');
  
  if (isExpanding) {
    const answer = answerWrap.querySelector('.faq__a');
    answerWrap.style.maxHeight = calcHeight(answer) + 'px';
    answerWrap.addEventListener('transitionend', () => answerWrap.style.maxHeight = '', { once: true });
  }
  else {
    answerWrap.style.maxHeight = answerWrap.offsetHeight + "px";
    window.setTimeout(() => {
      answerWrap.style.maxHeight = "0";
      answerWrap.addEventListener('transitionend', function() { this.style.maxHeight = '';}, { once: true });
    }, 1);
  }

  window.setTimeout(() => { 
    faqItem.classList.toggle('faq__item--open', isExpanding);
  }, 2);
}

function calcHeight(el) {
  let height = el.offsetHeight;
  
  if (el.firstChild) {
    const mt = window.getComputedStyle(el.firstChild).marginTop;
    
    if (mt && mt.includes('px')) {
      height += parseInt(mt.replace('px', ''));
    }
  }
  
  if (el.lastChild) {
    const mb = window.getComputedStyle(el.lastChild).marginBottom;

    if (mb && mb.includes('px')) {
      height += parseInt(mb.replace('px', ''));
    }
  }

  window.x = window.getComputedStyle(el.firstChild);
  return height;
}

function configExpandable(parent) {
  const expandable = parent.querySelector('[data-expandable]');
  const expandableId = expandable.id
  const toggles = document.querySelectorAll(`[aria-controls="${ expandableId }"]`);
  
  parent.setAttribute('aria-live', 'polite');
  FocusManagement.disableFocusables(expandable);
  
  toggles.forEach(t => t.addEventListener('click', function() {
    const expanded = !parent.classList.contains('expanded');
    
    expanded ? FocusManagement.enableFocusables(expandable) : FocusManagement.disableFocusables(expandable);
  
    toggles.forEach(t => {
      t.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
    
    expandable.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    parent.classList.toggle('expanded');
  }));
}

const expander = { init };
export default expander;